import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Radio,
  RadioGroup,
  SelectionControlLabel
} from '@one-thd/sui-atomic-components';
import { DELIMITER } from './Constants';

const Quotes = ({
  quoteList,
  selectQuote,
  selectedQuote,
  showLoadMore,
  quotesPageSize,
  setQuotesPageSize
}) => {

  const handleLoadMore = () => {
    setQuotesPageSize(quotesPageSize + 20);
  };

  return (
    <div className="sui-pt-4">
      <RadioGroup
        aria-labelledby="quote-names"
        name="quote-names"
      >
        {quoteList.map((quote, i) => (
          <SelectionControlLabel
            key={quote.cartId}
            id={quote.cartId}
            onChange={selectQuote}
            value={`${quote.cartId}${DELIMITER}${quote.createdUserId}${DELIMITER}${quote.name}`}
            label={quote.name}
            checked={selectedQuote.quoteId === quote.cartId}
            padding="true"
          >
            <Radio />
          </SelectionControlLabel>
        ))}
      </RadioGroup>
      {showLoadMore && (
        <Button
          variant="text"
          onClick={handleLoadMore}
          data-testid="load-more-button"
        >
          Load More...
        </Button>
      )}
    </div>
  );
};

Quotes.propTypes = {
  quoteList: PropTypes.arrayOf(
    PropTypes.shape({
      quoteId: PropTypes.string,
      quoteName: PropTypes.string,
      userId: PropTypes.string
    })
  ).isRequired,
  selectedQuote: PropTypes.shape({
    quoteId: PropTypes.string,
    quoteName: PropTypes.string,
    userId: PropTypes.string
  }).isRequired,
  showLoadMore: PropTypes.bool.isRequired,
  setQuotesPageSize: PropTypes.func.isRequired,
  quotesPageSize: PropTypes.number.isRequired,
  selectQuote: PropTypes.func.isRequired
};

Quotes.displayName = 'Quotes';

export { Quotes };